import type { GamesFilter } from '@/api/games';

export const combineSubCategoryGames = (input: GamesFilter.Response[]) => {
  const result = [];
  const maxLength = Math.max(...input.map((obj) => obj.data.length));
  const seen = new Set<string>();

  for (let i = 0; i < maxLength; i++) {
    for (const obj of input) {
      const game = obj.data[i];
      if (game && !seen.has(game.identifier)) {
        seen.add(game.identifier);
        result.push(game);
      }
    }
  }

  return result;
};
